class EmployerDashboardQueryKeys {
  private prefix = 'employer-dashboard';

  getDashboard() {
    return [this.prefix];
  }
}

export default EmployerDashboardQueryKeys;
